"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileData = exports.FileReaderType = void 0;
var FileReaderType;
(function (FileReaderType) {
    FileReaderType[FileReaderType["binary"] = 0] = "binary";
    FileReaderType[FileReaderType["arrayBuffer"] = 1] = "arrayBuffer";
})(FileReaderType = exports.FileReaderType || (exports.FileReaderType = {}));
const getFileData = (inputFile, type) => {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
            fileReader.abort();
            reject(new Error('Parsing error'));
        };
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        if (type === FileReaderType.binary) {
            fileReader.readAsBinaryString(inputFile);
        }
        else {
            fileReader.readAsArrayBuffer(inputFile);
        }
    });
};
exports.getFileData = getFileData;
